/**
 * The password meter, as a checklist.
 *
 * `settings-profile.html`, verbatim in its own note: "The strength indicator
 * describes what to do next instead of scoring the password out of five." Two
 * items, both always shown, each a 20px filled circle with a glyph and a 13px
 * label — met on `--mdx-hot` with `--mdx-hot-ink` text, unmet on
 * `--mdx-review` with `--mdx-review-ink`.
 *
 * BAND COLOURS FOR SOMETHING THAT IS NOT A BAND. `DESIGN-SYSTEM.md` §1 calls
 * hot and review semantic, and RULE-001 keeps the word "band" for one thing —
 * but the export uses these two here, and the export is the visual source of
 * truth. Nothing in the DOM calls it a band, no `score` is computed, and the
 * meaning is met/unmet, which is what the two colours already read as anywhere
 * else in the product.
 *
 * The RULE is `@leadgible/schema`'s `passwordChecklist`, so the auth screens'
 * sentence and this page's ticks cannot disagree about the thresholds.
 *
 * Story 4.3.
 */
import { passwordChecklist } from '@leadgible/schema'

export function PasswordChecks({ password }: { password: string }) {
  if (password.length === 0) return null
  return (
    <span className="mt-mdx-2 flex flex-wrap items-center gap-x-mdx-12 gap-y-mdx-8">
      {passwordChecklist(password).map((check) => (
        <span
          key={check.id}
          className={[
            'inline-flex items-center gap-mdx-8 text-mdx-13',
            check.met ? 'text-mdx-hot-ink' : 'text-mdx-review-ink',
          ].join(' ')}
        >
          <span
            aria-hidden="true"
            className={[
              'flex size-mdx-20 shrink-0 items-center justify-center rounded-mdx-pill',
              'text-mdx-11 font-mdx-bold text-mdx-white',
              check.met ? 'bg-mdx-hot' : 'bg-mdx-review',
            ].join(' ')}
          >
            {check.met ? '✓' : '◐'}
          </span>
          {check.label}
        </span>
      ))}
    </span>
  )
}
